module.exports = __webpack_public_path__ + "static/media/tableFrame.c5443940.svg";